import React from 'react'
import Alert from 'components/Alert'

const FeatureGuard = ({ featureName, user, children }) => {
  const featureKey = featureName.toLowerCase()
  const toggle = user.FeatureToggles.find(f => f.feature_name.toLowerCase() === featureKey.toLowerCase())
  if (toggle && !toggle.is_enabled && !user.IsAdmin) {
    return (
      <Alert showCloseButton={false} type="info">
        <b>{featureName} feature under maintenance...</b>
        {toggle.message ? (
          <p>{toggle.message}</p>
          ) : (
            <p>
              This feature is currently undergoing scheduled maintenance. We&apos;re working to have everything back up and running as soon as possible.
              Please check back later, and we apologize for the inconvenience.
            </p>
          )}
      </Alert>
    )
  }

  return (
    <div>
      { !toggle.is_enabled && user.IsAdmin &&
        <Alert showCloseButton={false} type="info">
          <b>Please note: This is the Admin view. These features are currently disabled for Partner users.</b>
        </Alert>
      }
      {children}
    </div>
  )
}

export default FeatureGuard



// WEBPACK FOOTER //
// ./src/components/FeatureToggle/FeatureGuard.js